import React from 'react';

function about() {
	 <div>
ssdsdfsdfsdadsdasfsfsdfsdfs
	 </div>;
}

export default about;
